import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { getStringProp } from '@mews/fp';
import { NAME } from './module';

const getDialogs = (state: ApplicationState) => state[NAME];

export const isDialogOpen = createSelector(getDialogs, getStringProp('name'), (dialogState, name) =>
    get([name, 'open'], dialogState)
);

export const getDialogState = createSelector(getDialogs, getStringProp('name'), (dialogState, name) =>
    get([name], dialogState)
);
